import axios from 'axios';
import API_BASE_URL from './api';

const API = `${API_BASE_URL}/api`;
const authHeaders = (token) => (token ? { Authorization: `Bearer ${token}` } : {});

// Floutage automatique des visages sur une image téléversée (fondateur).
export const blurFaces = async (file, strength, token) => {
  const form = new FormData();
  form.append('file', file);
  if (strength != null) form.append('strength', String(strength));
  const res = await axios.post(`${API}/admin/tools/blur-faces`, form, {
    withCredentials: true,
    headers: { ...authHeaders(token), 'Content-Type': 'multipart/form-data' },
  });
  return res.data; // { url, faces_detected }
};

// Floutage manuel de zones précises (normalisées 0-1) sur une image déjà dans /uploads.
export const blurRegions = async (imageUrl, regions, strength, token) => {
  const res = await axios.post(`${API}/admin/tools/blur-regions`, {
    image_url: imageUrl, regions, strength,
  }, {
    withCredentials: true,
    headers: authHeaders(token),
  });
  return res.data; // { url, regions_applied }
};

// Bibliothèque : liste des images déjà téléversées dans /uploads
export const listUploads = async (token) => {
  const res = await axios.get(`${API}/admin/tools/uploads`, {
    withCredentials: true,
    headers: authHeaders(token),
  });
  return res.data; // { images: [{url, name, modified}] }
};
